export default "__VITE_ASSET__04P$$8r8__"